<template>
  <!-- -->
  <div class="defaultViewStyle">
    <el-tabs v-model="activeName" v-if="dataDetail.id">
      <el-tab-pane name="project" label="项目信息" lazy>
        <project-info v-model="dataDetail"/>
      </el-tab-pane>
      <el-tab-pane name="site" label="工地列表" lazy>
        <project-site-list :project-id="route.query.id"/>
      </el-tab-pane>
      <el-tab-pane name="classmate" label="施工班组" lazy>
        <list-table style="height: 100%">
          <classmate-table :data="classmateList"/>
        </list-table>
      </el-tab-pane>
<!--      <el-tab-pane label="项目组人员" name="employee" lazy>-->
<!--        <project-employee v-model="dataDetail"/>-->
<!--      </el-tab-pane>-->
      <el-tab-pane name="laborers" label="劳务人员" lazy>
        <list-table style="height: 100%">
          <laborers-table :data="laborersList"/>
        </list-table>
      </el-tab-pane>
    </el-tabs>
    <project-info v-model="dataDetail" v-else/>
  </div>
</template>

<script>
import ListTable from "@/components/h5/layout/ListTable.vue";
import {useRoute, useRouter} from "vue-router";
import ProjectInfo from "@/views/h5/luqiao/project/project/ProjectInfo.vue";
import ProjectSiteList from "@/views/h5/luqiao/project/project/ProjectSiteList.vue";
import LaborersTable from "@/views/h5/luqiao/display/LaborersTable.vue";
import ClassmateTable from "@/views/h5/luqiao/display/ClassmateTable.vue";
import projectApi from "@/api/dz-luqiao/luqiaoProjectApi";
import ProjectEmployee from "@/views/h5/luqiao/project/project/ProjectEmployee.vue";
import Util from "@/util/util";

export default {
  computed: {

  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "ProjectDetail",
  components: {
    ListTable, ProjectInfo, ProjectSiteList, LaborersTable, ClassmateTable, ProjectEmployee
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (this.route.query.id) {
      this.findById(this.route.query.id)
    }
  },
  data() {
    return {
      dataDetail: {},
      activeName: "project",
      // eslint-disable-next-line vue/no-dupe-keys
      laborersList: [], // 劳务人员
      classmateList: [] // 施工队
    };
  },
  methods: {
    async findById(id) {
      const [projectRes, classmateRes, workersRes] = await Promise.all([
        projectApi.findById(id),
        projectApi.queryClassmateByProjectId(id),
        projectApi.queryWorkersByProjectId(id)
      ]);
      // 将返回的数据赋值给相应的变量
      this.dataDetail = projectRes;
      this.classmateList = classmateRes;
      this.laborersList = workersRes;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tabs";
</style>